import { Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from '@aimsos/auth';
import GlobalAuditPage from './GlobalAuditPage.jsx';

/** Global Audit routes (CT-3901), mounted at /admin-studio/audit. */
const AuditRoutes = () => (
  <Routes>
    <Route
      index
      element={
        <ProtectedRoute>
          <GlobalAuditPage />
        </ProtectedRoute>
      }
    />
    <Route path="*" element={<Navigate to="" replace />} />
  </Routes>
);

export default AuditRoutes;
